/* WJW 18: mirror the native AJAX facet count into the single mobile heading;
   Shopify's existing search/facet engine still owns filtering and sorting. */
(() => {
  'use strict';
  if (!document.body.classList.contains('template-search')) return;
  const target = document.querySelector('.wjw-search-heading-count');
  if (!target) return;
  let frame = 0;
  function refresh() {
    frame = 0;
    const native = document.querySelector('#ProductCount .facets__label');
    if (!native) return;
    const count = native.textContent.match(/\d[\d,.]*/);
    if (count) target.textContent = count[0] + ' results';
  }
  const schedule = () => {if (!frame) frame=requestAnimationFrame(refresh);};
  const grid = document.querySelector('#ProductGridContainer');
  if (grid) new MutationObserver(schedule).observe(grid,{subtree:true,childList:true,characterData:true});
  document.addEventListener('facet:updated',schedule);
  document.addEventListener('shopify:section:load',schedule);
  refresh();
})();
